<div class="page-header"><h1 class="page-title">Agent Approval</h1></div>
<div class="row">
	<div class="col mb-3">
		<button class="btn btn-outline-success w-25 me-2" [disabled]="!approval" (click)="doApprove()">Approve</button>
		<button class="btn btn-outline-danger w-25 me-2" [disabled]="!approval" (click)="doReject()">Reject</button>
		<button class="btn btn-outline-secondary w-25" [disabled]="!approval" (click)="doSkip()">Skip</button>
	</div>
</div>
<div class="row" *ngIf="!approval">
	<nz-empty nzNotFoundImage="simple" nzNotFoundContent="No agents pending approval"></nz-empty>
</div>
<div class="row" *ngIf="approval">
	<div class="col">
		<table>
			<tr><td class="pe-3">Username:</td><td>{{approval.agent.username}}</td></tr>
			<tr><td class="pe-3">Email:</td><td>{{approval.agent.emailAddress}}</td></tr>
			<tr><td class="pe-3">Msisdn:</td><td>{{approval.agent.msisdn}}</td></tr>
			<tr><td class="pe-3">Partner:</td><td>{{approval.agent.partner!.name}}</td></tr>
			<tr><td class="pe-3">Role:</td><td>{{approval.agent.appRole!.name}}</td></tr>
		</table>
	</div>
</div>

<div class="row"*ngIf="approval">
	<div class="col">
		<div class="card">
			<div class="card-header text-center">Compare Agent Information</div>
			<div class="card-body">
				<div class="row">
					<div class="col">
						<div class="card">
							<div class="card-header text-center">Side Match (Left)</div>
							<div class="card-body">
								<div class="row">
									<div class="col">
										<nz-radio-group [(ngModel)]="selectedViewLeft">
											<label nz-radio nzValue="government">Government Data</label>
											<label nz-radio nzValue="portrait">Portrait</label>
											<label nz-radio nzValue="documentFront">Document Front</label>
											<label nz-radio nzValue="documentBack">Document Back</label>

											<label *ngIf="this.approval.agent.governmentPhotoImage" nz-radio nzValue="governmentPhoto">Government Photo</label>
											<label *ngIf="this.approval.agent.governmentPassportImage" nz-radio nzValue="governmentPassport">Government Passport</label>
										</nz-radio-group>
									</div>
								</div>
								<div class="row">
									<div class="col">
										<ng-container [ngTemplateOutlet]="getTemplate(selectedViewLeft)"></ng-container>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="col">
						<div class="card">
							<div class="card-header text-center">Side Match (Right)</div>
							<div class="card-body">
								<div class="row">
									<div class="col">
										<nz-radio-group [(ngModel)]="selectedViewRight">
											<label nz-radio nzValue="government">Government Data</label>
											<label nz-radio nzValue="portrait">Portrait</label>
											<label nz-radio nzValue="documentFront">Document Front</label>
											<label nz-radio nzValue="documentBack">Document Back</label>

											<label *ngIf="this.approval.agent.governmentPhotoImage" nz-radio nzValue="governmentPhoto">Government Photo</label>
											<label *ngIf="this.approval.agent.governmentPassportImage" nz-radio nzValue="governmentPassport">Government Passport</label>
										</nz-radio-group>
									</div>
								</div>
								<div class="row">
									<div class="col">
										<ng-container [ngTemplateOutlet]="getTemplate(selectedViewRight)"></ng-container>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
<ng-template #refPortrait>
	<img [src]="portraitImageUrl" style="width: 100%;" *ngIf="portraitImageUrl"/>
	<nz-empty nzNotFoundImage="simple" nzNotFoundContent="No image selected" *ngIf="!portraitImageUrl"></nz-empty>
</ng-template>
<ng-template #refDocumentFront>
	<img [src]="documentFrontImageUrl" style="width: 100%;" *ngIf="documentFrontImageUrl"/>
	<nz-empty nzNotFoundImage="simple" nzNotFoundContent="No image selected" *ngIf="!documentFrontImageUrl"></nz-empty>
</ng-template>
<ng-template #refDocumentBack>
	<img [src]="documentBackImageUrl" style="width: 100%;" *ngIf="documentBackImageUrl"/>
	<nz-empty nzNotFoundImage="simple" nzNotFoundContent="No image selected" *ngIf="!documentBackImageUrl"></nz-empty>
</ng-template>

<ng-template #refGovernmentPhoto>
	<img [src]="governmentPhotoImageUrl" style="width: 100%;" *ngIf="governmentPhotoImageUrl"/>
	<nz-empty nzNotFoundImage="simple" nzNotFoundContent="No image selected" *ngIf="!governmentPhotoImageUrl"></nz-empty>
</ng-template>
<ng-template #refGovernmentPassport>
	<img [src]="governmentPassportPhotoImageUrl" style="width: 100%;" *ngIf="governmentPassportPhotoImageUrl"/>
	<nz-empty nzNotFoundImage="simple" nzNotFoundContent="No image selected" *ngIf="!governmentPassportPhotoImageUrl"></nz-empty>
</ng-template>

<ng-template #refGovernment>
	<table class="table table-sm table-borderless">
		<tbody>
			<tr><td>Loaded At</td><td>{{approval.agent.governmentRecord!.createdAt | date}}</td></tr>
			<tr><td>Document Type</td><td>{{approval.agent.governmentRecord!.documentType}}</td></tr>
			<tr><td>Document Number</td><td>{{approval.agent.governmentRecord!.documentNumber}}</td></tr>
			<tr><td>ID Number</td><td>{{approval.agent.governmentRecord!.idNumber}}</td></tr>
			<tr><td>First Name</td><td>{{approval.agent.governmentRecord!.firstName}}</td></tr>
			<tr><td>Other Names</td><td>{{approval.agent.governmentRecord!.otherName}}</td></tr>
			<tr><td>Last Name</td><td>{{approval.agent.governmentRecord!.surname}}</td></tr>
			<tr><td>Family</td><td>{{approval.agent.governmentRecord!.family}}</td></tr>
			<tr><td>Gender</td><td>{{approval.agent.governmentRecord!.gender}}</td></tr>
			<tr><td>Date of Birth</td><td>{{approval.agent.governmentRecord!.dateOfBirth | date}}</td></tr>
			<tr><td>Date of Issue</td><td>{{approval.agent.governmentRecord!.dateOfIssue | date}}</td></tr>
			<tr><td>Date of Expiry</td><td>{{approval.agent.governmentRecord!.dateOfExpiry | date}}</td></tr>
			<tr><td>Date of Death</td><td>{{approval.agent.governmentRecord!.dateOfDeath | date}}</td></tr>
			<tr><td>Citizenship</td><td>{{approval.agent.governmentRecord!.citizenship}}</td></tr>
			<tr><td>Clan</td><td>{{approval.agent.governmentRecord!.clan}}</td></tr>
			<tr><td>Ethnic Group</td><td>{{approval.agent.governmentRecord!.ethnicGroup}}</td></tr>
			<tr><td>Occupation</td><td>{{approval.agent.governmentRecord!.occupation}}</td></tr>
			<tr><td>Place Of Birth</td><td>{{approval.agent.governmentRecord!.placeOfBirth}}</td></tr>
			<tr><td>Place Of Death</td><td>{{approval.agent.governmentRecord!.placeOfDeath}}</td></tr>
			<tr><td>Place Of Live</td><td>{{approval.agent.governmentRecord!.placeOfLive}}</td></tr>
			<tr><td>Reg Office</td><td>{{approval.agent.governmentRecord!.regOffice}}</td></tr>
		</tbody>
	</table>
</ng-template>


<!-- Reject Modal Template -->
<ng-template #rejectModal let-modal>
	<div class="modal-header">
		<h5 class="modal-title">Reject Agent</h5>
		<button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
	</div>

	<div class="modal-body">
		<div class="mb-3">
			<label for="reason" class="form-label">Reason</label>
			<select id="reason" class="form-select" [(ngModel)]="rejectReason">
				<option [ngValue]="null" disabled>Select a reason</option>
				<option *ngFor="let reason of rejectReasons" [value]="reason">{{ reason }}</option>
			</select>
		</div>
		<div class="mb-3">
			<label for="comment" class="form-label">Comment</label>
			<textarea id="comment" class="form-control" rows="3" [(ngModel)]="rejectComment" placeholder="Optional comment..."></textarea>
		</div>
	</div>

	<div class="modal-footer">
		<button type="button" class="btn btn-secondary" (click)="modal.dismiss()">Cancel</button>
		<button type="button" class="btn btn-danger" [disabled]="!rejectReason" (click)="submitReject(modal)">Reject</button>
	</div>
</ng-template>
